import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import * as classNames from "classnames";
import { TopicContext } from "store/contexts/topicContext";
import TopicDailog from "./TopicDailog";
import { useFormik } from "formik";
import CustomTextArea from "components/CustomTextArea";
import { ReactComponent as Edit } from "assets/img/icons/Edit.svg";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { ReactComponent as TickIcon } from "assets/img/icons/tick.svg";
import { ReactComponent as Add } from "assets/img/icons/add.svg";
import { useTeamContext } from "store/contexts/teamContext";
import TeamService from "services/TeamService";
import { useDispatch } from "react-redux";
import * as timelineActions from "reteamStore/actions";
import { useUserContext } from "store/contexts/userContext";
import * as moment from "moment";

export default () => {
  const { team, setTeam } = useTeamContext();
  const dispatch = useDispatch();
  const [latestTopic, setLatestTopic] = useState(null);
  const [dialogState, setDialogState] = useState(false);
  const { user } = useUserContext();
  const [blinkTopic, setBlinkTopic] = useState(false);
  const [showTopicDialog, setShowTopicDialog] = useState(team?.latest_topic);

  const formik = useFormik({
    initialValues: {
      editView: false,
      createNew: false,
      topic: "",
    },
    validationSchema: Yup.object().shape({
      topic: Yup.string()
        .min(6, "Topic should be 6 to 5000 characters.")
        .max(5000, "Topic should be 6 to 5000 characters.")
        .required(),
    }),
    onSubmit: async (values) => {
      setDialogState(false);
      setShowTopicDialog(values.topic);
      let topic = null;

      if (values.createNew) {
        await TeamService.createTeamTopic(team.id, values.topic.trim());
        const response = await TeamService.getTeamTopic(team.id);

        if (team?.latest_topic) {
          dispatch(timelineActions.createPost(latestTopic));
        }

        setLatestTopic({
          ...response.data.data,
        });

        topic = {
          ...response.data.data.data,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        };
      } else if (values.editView) {
        await TeamService.updateTeamTopic(
          team.id,
          team?.latest_topic?.id,
          values.topic.trim()
        );

        topic = {
          ...team.latest_topic,
          content: values.topic.trim(),
        };

        setLatestTopic({
          ...latestTopic,
          data: {
            ...latestTopic,
            content: values.topic.trim(),
          },
        });
      }

      setTeam({
        ...team,
        latest_topic: topic,
      });
      formik.resetForm();
    },
  });

  useEffect(() => {
    (async () => {
      try {
        const response = await TeamService.getTeamTopic(team.id);

        setLatestTopic(response.data.data);
      } catch (e) {
        // console.log(e, "Get Team Topic Error");
      }
    })();

    //eslint-disable-next-line
  }, []);

  const updateTopic = (topic) => {
    setLatestTopic(topic);
  };

  useEffect(() => {
    if (!team.latest_topic) {
      return;
    }

    var topicCreated = moment(team?.latest_topic?.created_at);
    var uptoSevenDays = moment(team?.latest_topic?.created_at).add(7, "days");

    if (
      moment(new Date()).isSameOrAfter(topicCreated) &&
      moment(new Date()).isSameOrBefore(uptoSevenDays)
    ) {
      setBlinkTopic(true);
      return;
    }

    // setBlinkTopic(false);
  }, [team.latest_topic]);

  return (
    <>
      <div className="team-topic-box">
        <div className="team-topic">
          <h5 className="title-topic">
            {formik.values.editView && "Edit Topic"}
            {formik.values.createNew && "Create New Team Topic"}
            {!formik.values.createNew &&
              !formik.values.editView &&
              "Team Topic"}
          </h5>
          {!!team?.latest_topic &&
            !formik.values.editView &&
            !formik.values.createNew &&
            ([3, 2].includes(team?.role_id) ||
              latestTopic?.user?.id === user?.id) && (
              <Edit
                className="me-2"
                title="Edit existing topic"
                style={{ width: "16px", cursor: "pointer" }}
                onClick={() => {
                  formik.setFieldValue("editView", true);
                  formik.setFieldValue("topic", team?.latest_topic?.content);
                }}
              />
            )}
          {!formik.values.editView && !formik.values.createNew && (
            <Add
              className="ms-1"
              style={{ width: "16px", fill: "#a1a2a9", cursor: "pointer" }}
              onClick={() => {
                formik.setFieldValue("createNew", true);
                formik.setFieldValue("topic", "");
              }}
            />
          )}
          {!formik.isSubmitting &&
            (formik.values.editView || formik.values.createNew) && (
              <CancelIcon
                className="me-2"
                style={{ width: "16px", fill: "#a1a2a9", cursor: "pointer" }}
                onClick={() => {
                  if (formik.isSubmitting) {
                    return;
                  }

                  formik.setFieldValue("editView", false);
                  formik.setFieldValue("createNew", false);
                  setDialogState(false);
                }}
              />
            )}
          {!formik.isSubmitting &&
            formik.isValid &&
            (formik.values.editView || formik.values.createNew) && (
              <TickIcon
                style={{ width: "16px", fill: "#a1a2a9", cursor: "pointer" }}
                className="ms-1"
                onClick={formik.handleSubmit}
              />
            )}
        </div>
        <div
          onClick={() => setDialogState(true)}
          className={classNames({
            "topic-list": true,
            createdTopic: blinkTopic ? true : false,
            topicBodyData: showTopicDialog && true,
            topicBodyNoData:
              !showTopicDialog && !formik.values.createNew && true,
            customScrollArea: true,
          })}
          style={{
            maxHeight: "100px",
            overflow: "auto",
          }}
        >
          {!formik.values.createNew && !formik.values.editView && (
            <>
              {team?.latest_topic?.content ||
                "No topic has been created for this team"}
            </>
          )}
          {(formik.values.createNew || formik.values.editView) && (
            <CustomTextArea
              formik={formik}
              fieldName={"topic"}
              limit={165}
              rows={4}
              fontSize={"14px"}
              textalign={"left"}
              padding={"10px"}
              disabled={formik.isSubmitting}
            />
          )}
        </div>
      </div>
      <TopicContext.Provider
        value={{
          updateTopic,
        }}
      >
        {!formik.values.editView && !formik.values.createNew && (
          <TopicDailog
            dialogState={dialogState}
            latestTopic={latestTopic}
            setDialogState={setDialogState}
          />
        )}
      </TopicContext.Provider>
    </>
  );
};
